import { Info, X } from 'lucide-react'
import { Link, useLocation } from 'react-router-dom'
import { useEffect, useState } from 'react'

import { useModules } from '@/hooks/useModule'
import { useT } from '@/lib/i18n/AdminI18nProvider'
import { cn } from '@/lib/utils'

const DISMISS_KEY = 'admin:platform-modules-notice:dismissed'

export function PlatformModulesNotice() {
  const t = useT()
  const { pathname } = useLocation()
  const { data, isLoading } = useModules()
  const [dismissed, setDismissed] = useState(true)

  useEffect(() => {
    setDismissed(localStorage.getItem(DISMISS_KEY) === '1')
  }, [])

  if (pathname === '/plan-modules' || dismissed || isLoading || !data) return null

  const total = data.modules.length
  const enabled = data.enabledKeys.length
  const disabled = total - enabled

  return (
    <div className={cn('relative mb-4 flex flex-col gap-2 rounded-xl border border-amber-300/80 bg-amber-50 px-4 py-3 text-sm text-amber-950',
        'dark:border-amber-700/60 dark:bg-amber-950/40 dark:text-amber-100',)} role="status">
      <button type="button" aria-label={t('modules.notice.dismiss')}
        onClick={() => {
          localStorage.setItem(DISMISS_KEY, '1')
          setDismissed(true)
        }} className="absolute right-2 top-2 rounded-md p-1 text-amber-700/70 hover:bg-amber-200/60 dark:text-amber-200/70 dark:hover:bg-amber-900/50">
        <X className="h-4 w-4" />
      </button>

      <div className="flex items-start gap-2 pr-8">
        <Info className="mt-0.5 h-4 w-4 shrink-0" aria-hidden />
        <div className="space-y-1">
          <p className="font-semibold">{t('modules.notice.title')}</p>
          <p className="text-xs leading-relaxed opacity-90"
            dangerouslySetInnerHTML={{ __html: t('modules.notice.body') }}
          />
          <p className="text-xs opacity-80">
            <span dangerouslySetInnerHTML={{ __html: t('modules.notice.status', { enabled: String(enabled), disabled: String(disabled) }) }} />
            {' · '}
            <Link to="/plan-modules" className="font-medium underline underline-offset-2 hover:opacity-80">
              {t('modules.notice.viewAll')}
            </Link>
          </p>
        </div>
      </div>
    </div>
  )
}
